module.exports = __webpack_public_path__ + "static/media/logo-restyle-black.ad90e794.svg";